/** @jsxImportSource @emotion/react */
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { BillingNoteDto, BillingNoteEntityType } from 'store/types'
import { BillingNotes } from './BillingNotes'

// What a notes dialog is opened against. `notes` is deliberately not part of
// this: the caller derives them from its own live list so the dialog and the
// row count cannot drift apart after a write.
export type NotesTarget = {
  type: BillingNoteEntityType
  entityId: string
  title: string
}

interface Props {
  target: NotesTarget | null
  notes: BillingNoteDto[]
  onClose: () => void
  onChange: () => void
}

// Every level opens its notes here rather than expanding a panel in place —
// the payments and charges tables are dense enough already.
export const BillingNotesModal: React.FC<Props> = ({ target, notes, onClose, onChange }) => (
  <Modal show={Boolean(target)} onHide={onClose} centered>
    <Modal.Header>
      <Modal.Title css={{ fontSize: '1.05rem' }}>{target?.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {target && (
        <BillingNotes
          notes={notes}
          type={target.type}
          entityId={target.entityId}
          onChange={onChange}
        />
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)
